import {DataFetcher} from '@aboutyou/data-fetcher';
import {useHistory} from '@aboutyou/router';
import {ErrorPageInline, FullPageSpinner} from '@aboutyou/ui-components';
import React from 'react';
import {CampaignConfirmationView} from './CampaignConfirmationView';
import {useSubmitCRMEventToken} from './utils/useSubmitCRMEventToken';

export const CampaignConfirmation: React.FC = () => {
  const history = useHistory();
  const params = new URLSearchParams(history.location.search);
  const jwtToken = params.get('crm_event_payload');

  return (
    <DataFetcher
      request={useSubmitCRMEventToken(jwtToken)}
      Loading={FullPageSpinner}
      Error={ErrorPageInline}
      View={CampaignConfirmationView}
    />
  );
};
